const BADGE_FOLDER = {
  first_lesson:     'common',
  '7day_streak':    'common',
  '100_questions':  'rare',
  accuracy_80:      'rare',
  review_hero:      'rare',
  '500_questions':  'epic',
  accuracy_90:      'epic',
  level_1_complete: 'epic',
  level_3_complete: 'epic',
  level_5_complete: 'epic',
  '30day_streak':   'legendary',
  review_master:    'legendary',
}

const RARITY_STYLE = {
  common:    { label: 'Common',    color: '#22C55E', bg: '#F0FDF4', grad: 'linear-gradient(135deg,#F0FDF4,#DCFCE7)' },
  rare:      { label: 'Rare',      color: '#3B82F6', bg: '#EFF6FF', grad: 'linear-gradient(135deg,#EFF6FF,#DBEAFE)' },
  epic:      { label: 'Epic',      color: '#F59E0B', bg: '#FFFBEB', grad: 'linear-gradient(135deg,#FFFBEB,#FEF3C7)' },
  legendary: { label: 'Legendary', color: '#9333EA', bg: '#F3E8FF', grad: 'linear-gradient(135deg,#F3E8FF,#E9D5FF)' },
}

const BADGE_PROGRESS_HINT = {
  first_lesson:     'Complete your first lesson',
  '100_questions':  '0 / 100',
  '500_questions':  '0 / 500',
  '7day_streak':    '0 / 7 days',
  '30day_streak':   '0 / 30 days',
  review_hero:      'Complete your first review',
  review_master:    '0 / 10 reviews',
  accuracy_80:      '0 / 80%',
  accuracy_90:      '0 / 90%',
  level_1_complete: 'Complete Level 1',
  level_3_complete: 'Complete Level 3',
  level_5_complete: 'Complete Level 5',
}

// badge_key 기준 등급 반환
const getRarity = (badgeKey) => {
  const folder = BADGE_FOLDER[badgeKey] || 'common'
  return RARITY_STYLE[folder]
}

// gem_reward 기준 등급 반환 (BadgeSummaryCard에서 사용)
const getRarityByGem = (gem) => {
  if (gem >= 30) return RARITY_STYLE.legendary
  if (gem >= 15) return RARITY_STYLE.epic
  if (gem >= 10) return RARITY_STYLE.rare
  return RARITY_STYLE.common
}

const HEXAGON_CLIP = 'polygon(50% 0%, 93% 25%, 93% 75%, 50% 100%, 7% 75%, 7% 25%)'

const BadgeCard = ({ badge, isEarned, earnedDate }) => {
  const folder  = BADGE_FOLDER[badge.badge_key]
  const imageSrc = folder ? `/assets/badges/${folder}/${badge.badge_key}.png` : null
  const hint    = BADGE_PROGRESS_HINT[badge.badge_key] || ''
  const rarity  = getRarity(badge.badge_key)

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 10,
      padding: '20px 8px 16px',
      borderRadius: 16,
      background: isEarned ? '#fff' : '#F8FAFC',
      border: `1.5px solid ${isEarned ? '#E2E8F0' : '#EDF2F7'}`,
      transition: 'transform .15s, box-shadow .15s',
    }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(13,42,79,.10)' }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none' }}
    >
      {/* 육각형 아이콘 */}
      <div style={{ position: 'relative', width: 80, height: 80 }}>
        <div style={{
          width: 80,
          height: 80,
          clipPath: HEXAGON_CLIP,
          background: isEarned ? rarity.grad : 'linear-gradient(135deg,#E9EEF5,#DDE3EC)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}>
          {imageSrc ? (
            <img
              src={imageSrc}
              alt={badge.badge_name}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                filter: isEarned ? 'none' : 'grayscale(1) opacity(0.55)',
              }}
            />
          ) : (
            <img src="/assets/icons/medal.png" alt="badge" style={{ width: 34, height: 34, objectFit: 'contain', filter: isEarned ? 'none' : 'grayscale(1) opacity(0.55)' }} />
          )}
        </div>

        {/* 상태 인디케이터 */}
        <div style={{
          position: 'absolute',
          top: 0,
          right: 2,
          width: 22,
          height: 22,
          borderRadius: '50%',
          background: isEarned ? '#22C55E' : '#CBD5E1',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2px solid #fff',
          boxShadow: '0 1px 4px rgba(0,0,0,.12)',
        }}>
          {isEarned
            ? <span style={{ color: '#fff', fontSize: 11, fontWeight: 900, lineHeight: 1 }}>✓</span>
            : <img src="/assets/icons/lock.png" alt="locked" style={{ width: 10, height: 10, objectFit: 'contain' }} />
          }
        </div>
      </div>

      {/* 배지명 */}
      <p style={{
        margin: 0,
        fontSize: 12,
        fontWeight: 700,
        color: isEarned ? '#1E293B' : '#94A3B8',
        textAlign: 'center',
        lineHeight: 1.4,
        maxWidth: '90%',
      }}>
        {badge.badge_name}
      </p>

      {/* 상태 텍스트 */}
      {isEarned ? (
        <div style={{ textAlign: 'center' }}>
          <p style={{ margin: 0, fontSize: 11, fontWeight: 700, color: '#22C55E' }}>Earned</p>
          {earnedDate && (
            <p style={{ margin: '2px 0 0', fontSize: 10, color: '#94A3B8' }}>
              {formatDate(earnedDate)}
            </p>
          )}
        </div>
      ) : (
        <p style={{ margin: 0, fontSize: 11, color: '#B0BBC8', fontWeight: 500, textAlign: 'center' }}>{hint}</p>
      )}
    </div>
  )
}

const formatDate = (dateStr) => {
  if (!dateStr) return ''
  try {
    const d = new Date(dateStr)
    return d.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })
  } catch { return dateStr }
}

export { getRarity, getRarityByGem, BADGE_FOLDER }
export default BadgeCard
